import React, { useEffect, useState } from 'react';
import { User, Eye, X } from 'lucide-react';
import { getPriorityColor, getStatusColor } from '../../utils/colors';
import TasksTabAll from '../../components/task/TasksTabAll';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import taskApi from '../../api/taskApi';
import { useSelector } from 'react-redux';
import workflowApi from '../../api/workflowApi';
import { confirmSubmit } from '../../utils/confirmSubmit';

export const TasksTab = ({ workflowTemplatesTasks, onRefreshAccounts }) => {
    const [showCreateTask, setShowCreateTask] = useState(false);
    const currentUserId = useSelector((state) => state.auth.userdetails.id);
    const [attachments, setAttachments] = useState([]);
    const [comments, setComments] = useState([{ content: "" }]);
    const [taskId, setTaskId] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedClientData, setSelectedClientData] = useState(null);
    const token = useSelector((state) => state.auth.access_token);
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        dueDate: "",
        startDate: "",
        updatedDate: "",
        priority: "",
        status: "TODO",
        workflow: "",
        account: "",
        assignedTo: "",
        createdBy: "",
        workflowId: 0,
      });

    useEffect(()=> {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        setFormData(prev => ({
            ...prev,
            updatedDate: today.toISOString().split("T")[0],
            startDate: today.toISOString().split("T")[0],
            dueDate: tomorrow.toISOString().split("T")[0],
            createdBy: {id: currentUserId}
        }));
    }, []);
    

    // Flatten all tasks
    const allTasks = workflowTemplatesTasks.flatMap(wf =>
        (wf.tasks || []).map(task => ({
            ...task,
            workflowName: wf.name || "Untitled Workflow",
        }))
    );

    const workflowDropdown = workflowTemplatesTasks.flatMap(wf =>({
        value: wf.id,
        label: wf.name,
    }));

    const handleDeleteTask = async (task) => {
        const isConfirmed = await confirmSubmit({
                          title: "Confirm task delete",
                          text: "Are you sure you want to delete this task?",
                          confirmText: "Submit",
                        });
                      if (!isConfirmed) return;
            const workflowId = workflowDropdown.find( (item) => item.label === task.workflowName )?.value;
        try {
            await workflowApi.removeTasksFromWorkflow(workflowId, task?.id, token);
            onRefreshAccounts();
            toast.success("Task deleted successfully");
        } catch (err) {
            toast.error("Failed to delete task");
            console.error("Failed to delete task", err);
        }
        
    };

    const [errors, setErrors] = useState({});
        const safeTrim = (value) => (value || "").trim();
      
        const validateForm = () => {
              const newErrors = {};
      
              if (!safeTrim(formData.title))
                  newErrors.title = "Title is required";
      
              if (!safeTrim(formData.assignedTo))
                  newErrors.assignedTo = "Assigned To is required";
      
              if (!formData.workflowId)
                  newErrors.workflowId = "Workflow is required";
              if (!formData.account)
                  newErrors.account = "Account is required";
              if (!formData.status)
                  newErrors.status = "Status is required";
              if (!formData.priority)
                  newErrors.priority = "Priority is required";
              if (!formData.startDate)
                  newErrors.startDate = "Start Date is required";
              if (!formData.dueDate)
                  newErrors.dueDate = "Due Date is required";
              if (!formData.description)
                  newErrors.description = "Description is required";
      
              setErrors(newErrors);
              return Object.keys(newErrors).length === 0;
              };
      

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
                toast.error("Please fill all required fields correctly.");
                setIsLoader(false);
                return;
            }
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        const formattedComments = comments.filter(c => c?.content?.trim() !== "");

            const payload = {
            //   ...formData,
              assignedTo: { id: formData.assignedTo },
              account: { id: formData.account },
              createdBy: { id: currentUserId},
              title: formData.title,
              description: formData.description,
              dueDate: formData.dueDate,
              startDate: formData.startDate,
              updatedDate: formData.updatedDate,
              priority: formData.priority,
              status: formData.status,
            //   workflow: formData.workflow
            attachments: attachments,
            comments: formattedComments,
            };
        
        try {
          setIsLoader(true);
          if (taskId) {
            await taskApi.updateTask(taskId, payload, token);
            toast.success("Tasks updated Successfully");
            setShowCreateTask(false);
            onRefreshAccounts();
            setIsLoader(false);
            setFormData({
                title: "",
                description: "",
                priority: "",
                status: "TODO",
                workflow: "",
                account: "",
                assignedTo: "",
                createdBy: "",
                workflowId: 0,
                startDate: today.toISOString().split("T")[0],
                dueDate: tomorrow.toISOString().split("T")[0],
            });
            setTaskId(null);
            setAttachments([]);
            setComments([{ content: "" }]);
        } else {
            await workflowApi.addTasksForWorkflow(formData.workflowId, payload, token);
            toast.success("Tasks Created Successfully");
            setShowCreateTask(false);
            onRefreshAccounts();
            setIsLoader(false);
            setFormData({
                title: "",
                description: "",
                priority: "",
                status: "TODO",
                workflow: "",
                account: "",
                assignedTo: "",
                createdBy: "",
                workflowId: 0,
                startDate: today.toISOString().split("T")[0],
                dueDate: tomorrow.toISOString().split("T")[0],
            });
            setTaskId(null);
            setAttachments([]);
            setComments([{ content: "" }]);
          }
        } catch (err) {
          setIsLoader(false);
          console.error("Save failed", err);
        }
      };

    return ( 
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            {/* Header */}
            <TasksTabAll
                allTasks={allTasks}
                selectedClientData={selectedClientData}
                getStatusColor={getStatusColor}
                getPriorityColor={getPriorityColor}
                navigate={navigate}
                onRefreshAccounts={onRefreshAccounts}
                workflowDropdown={workflowDropdown}
                formData={formData}
                isLoader={isLoader}
                handleDeleteTask={handleDeleteTask}
                showCreateTask={showCreateTask}
                setShowCreateTask={setShowCreateTask}
                setFormData={setFormData}
                handleSubmit={handleSubmit}
                heading={"Task Management"}
                type={"workflow"}
                taskId={taskId}
                setTaskId={setTaskId}
                attachments={attachments}
                setAttachments={setAttachments}
                comments={comments}
                setComments={setComments}
                errors={errors}
            />
        </div>
    );
};
